/**
 * SearchControl
 *
 * View that deals with interactions in the search control. This includes;
 * validating the selected date and time, redirecting to private dining and
 * getting new results.
 *
 * @return {view}
 */

OT.createNS('OT.Search.Views.SearchControl');

OT.Search.Views.SearchControl = Backbone.ViewManager.BaseView.extend({

    el: '#search_control',

    events: {
        'keup #calendar'      : 'preventKeyPress',
        'keydown #calendar'   : 'preventKeyPress',
        'change #calendar'    : 'validateDateTime',
        'change #time'        : 'validateDateTime',
        'click #find_a_table' : 'newSearch'
    },

    initialize: function() {
        tombstone('SearchControl-js-initialize');
        // Store the UI elements this view
        this.$timeField     = this.$el.find('#time');
        this.$coversField   = this.$el.find('#covers');
        this.$calendarField = this.$el.find('#calendar');

        this.setDateAndTime();

        this.defaultPosition = {
            offset: this.$el.offset().top,
            position: this.$el.position().top
        };

        if(this.$el.parent().hasClass('sticky')) {
            OT.Events.on('scroll', $.proxy(this, 'toggleSticky'));
        }
    },


    getSelectedDate: function () {
        return this.$calendarField.val();
    },

    getSelectedTime: function () {
        return this.$timeField.val();
    },

    /**
     * Handle what happens when a new search is fired
     */
    newSearch: function() {
        OT.Search.Params.set({
            'DateTime': OT.Search.Helpers.convertDateToSearchDate(this.getSelectedDate(), this.getSelectedTime()),
            'Covers': this.$coversField.val(),
            'OnlyUnavailable': null,
            'From': 0
        });

        if(this.$coversField.val() === '21') {
            this.redirectToPrivateDining();
        } else {
            this.submitNewSearch();
        }
    },

    setDateAndTime: function() {
        var time = this.getSelectedTime();
        var date = this.getSelectedDate();

        // Check if the current date and time is valid
        var isValidDateTime = OT.Search.Helpers.isFutureDateTime(OT.Search.Helpers.convertDateTimeToTimestamp(date, time));

        // Store the next valid date if the date/time isn't valid
        this.currentTimeValue = isValidDateTime ? time : OT.Search.Helpers.getFormattedTime();
        this.currentDateValue = isValidDateTime ? date : OT.Search.Helpers.getFormattedDate();

        this.$timeField.val(this.currentTimeValue);
        this.$calendarField.val(this.currentDateValue);
    },


    /**
     * Check if the selected date and time is valid.
     * If it is, then we store those values for fallbacks incase the user selects an invalid date next
     */
    validateDateTime: function() {
        var selectedUTCTime = OT.Search.Helpers.convertDateTimeToTimestamp(this.$calendarField.val(), this.$timeField.val());
        var val = $('.search-control-container-validation');

        if(OT.Search.Helpers.isFutureDateTime(selectedUTCTime)) {
            this.currentTimeValue = this.getSelectedTime();
            this.currentDateValue = this.getSelectedDate();
            val.hide();
        } else {
            this.setDateAndTime();
            val.hide().fadeIn(300);
        }
    },


    /**
     * Redirect the user to the Private Dining page
     */
    redirectToPrivateDining: function() {
        var url = OT.Search.Data.get().Display.LargePartySearchUrl + OT.Search.Helpers.convertDateToSearchDate(this.getSelectedDate(), this.getSelectedTime());

        OT.Common.Helpers.redirectWindow(url);
    },


    /**
     * Fire a new search event and send a new search request to the API
     */
    submitNewSearch: function() {
        var $el = OT.Search.views.filters ? OT.Search.views.filters.$el : $();

        tombstone('SearchControl-js-submitNewSearch');
        OT.Search.Params.set(OT.Common.Helpers.buildObjectFromCheckedkItems($el));

        if(OT.Search.History.isSupported) {
            this.fireNewSearch();
        } else {
            this.redirectToInterim();
        }
    },

    fireNewSearch: function() {
        OT.Search.Requests.Results.get({
            additionalData: {
                isAvailabilityRequest: true
            }
        });
    },

    redirectToInterim: function() {
        OT.Common.Helpers.redirectWindow(OT.Search.Requests.BuildUrl.interim());
    },

    toggleSticky: function() {
        var $parent           = this.$el.parent();
        var $globalHeader     = $('#global_header');
        var $resultsContainer = OT.Search.views.resultsContainer ? OT.Search.views.resultsContainer.$el : undefined;

        var isSticky       = $parent.hasClass('stuck');
        var isHeaderFixed  = $globalHeader.css('position') === 'fixed';
        var scrollTop      = OT.Common.EnvInfo().Window.scrollTop + (isHeaderFixed ? $globalHeader.height() : 0) + 8;
        var shouldBeSticky = scrollTop >= this.defaultPosition.offset;

        if(shouldBeSticky && !isSticky) {
            $parent.addClass('stuck');

            if($resultsContainer) {
                $resultsContainer.css('margin-top', $parent.outerHeight() + 16);
            }
        } else if(!shouldBeSticky && isSticky) {
            $parent.removeClass('stuck');

            if($resultsContainer) {
                $resultsContainer.css('margin-top', 0);
            }
        }
    },


    /**
     * Block the user from typing inside the input field
     */
    preventKeyPress: function(e) {
        e.preventDefault();
    }

});